import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { setupPrimeVue } from './plugins/primevue'
import { AppSettings } from './settings/settings'

// Expose AppSettings as a global so the self-contained _apps/3cap screens
// (which run as raw JS with no runtime imports) can resolve the API base URL
// via _appsettings.server_url(). Declare the production URL in
// src/settings/settings.ts -> AppSettings.server_url().
;(window as any)._appsettings = AppSettings

// Import Tailwind CSS
import './themes/shared/styles/tailwind.css'

// Shared component styles for `.pulse-dashboard` dashboards
// (used by Transact/dashboards/ledger-pulse, flow-pulse, etc.)
import './themes/shared/styles/dashboard-pulse.css'

// Import Material Icons (keep for backwards compatibility)
import '@mdi/font/css/materialdesignicons.css'

async function bootstrap() {
  const app = createApp(App)

  // Setup Pinia store
  const pinia = createPinia()
  app.use(pinia)

  // Setup Router
  app.use(router)

  // Setup PrimeVue
  setupPrimeVue(app)

  // Mount app
  app.mount('#app')
}

// Bootstrap the application
bootstrap().catch(console.error)
